<template>
    <iframe id="landingPageIframe" :src="landingPageUrl" seamless="seamless" v-if="landingPageUrl"></iframe>
</template>

<script>
import commonAuth from '../services/commonAuth';

export default {
    name: "Landing Page",
    extends: commonAuth,
    data() {
        return {
            lpMap: {
                'Login': 'login',
                'SignUp': 'signup',
                'ForgotPassword': 'forgot-password',
                landingPageUrl: null
            }
        };
    },
    created() {
        if(process.env.VUE_APP_LANDING_PAGE) {
            this.landingPageUrl =  `${process.env.VUE_APP_LANDING_PAGE}${this.lpMap[this.$route.name] ?? 'index'}.html?v=${this.$siteSettings.data.version}`;
        } else {
            this.landingPageUrl = 'https://landingpage.' + `${location.host.replace('www.','')}` + '/' + `${this.lpMap[this.$route.name] ?? 'index'}.html?v=${this.$siteSettings.data.version}`;
        }
    },
    mounted(){
        if(this.$siteSettings.data.business_type == 1) {
            this.$router.push({ name: 'Home' });
            return;
        };
        let landingPageData;
        const signUpReferCode = this.$route.query.refer_code;
        const affiliateCode = this.$route.query.af_code;
        if (this.lpMap[this.$route.name] === 'signup' && (signUpReferCode || affiliateCode)) {
            landingPageData = JSON.parse(JSON.stringify({ ...this.$store.getters.siteSettings, signUpReferCode, affiliateCode }));
        } else {
            landingPageData = JSON.parse(JSON.stringify({ ...this.$store.getters.siteSettings }));
        }

        const iframe = document.getElementById('landingPageIframe'); 

        iframe.onload = () => {
            iframe.contentWindow.postMessage(landingPageData, '*');
        };
        window.addEventListener('message', this.checkForEvent);
    },
    methods: {
        async checkForEvent(event) {
            if(event.data.pageName) {
                this.$router.push({name: event.data.pageName});
            };
            if(event.data.type == 'demo') {
                this.demoUserLogin();
            } else if(event.data.type == 'nonDemo') {

                let loginFormData = event.data.loginDetails;
                let cnCode = event.data.loginDetails.countryCode;
                
                this.form = {
                    ...this.form,
                    type: parseInt(loginFormData.loginType),
                    userId: loginFormData.userid,
                    password: loginFormData.password,
                    code: cnCode.startsWith('+') ? cnCode.slice(1) : cnCode
                }

                if(loginFormData.loginType == 2) {
                    this.form.userId = loginFormData.userid;
                } else {
                    this.form.mobileNo = loginFormData.mobileNo;
                }

                await this.loginServiceCall('LOGIN_API', 'nondemo');

                const iframe = document.getElementById('landingPageIframe');
                let data = JSON.parse(JSON.stringify({ ...this.$store.getters.siteSettings, loginResponse: this.loginErrorRes }));
                iframe.contentWindow.postMessage(data, '*');

            } else if(event.data.type == 'login-with-otp') {

                let loginWithOTPFormData = event.data.loginWithOTPData;
                let cnCode = event.data.loginWithOTPData.countryCode;

                this.form = {
                    ...this.form,
                    type: parseInt(loginWithOTPFormData.loginType),
                    mobile: loginWithOTPFormData.mobileNo,
                    otp: loginWithOTPFormData.otp,
                    code: cnCode.startsWith('+') ? cnCode.slice(1) : cnCode
                }
               
                await this.signInwithOtp();

                const iframe = document.getElementById('landingPageIframe');
                let data = JSON.parse(JSON.stringify({ ...this.$store.getters.siteSettings, loginResponse: this.loginErrorRes }));
                iframe.contentWindow.postMessage(data, '*');

            } else if(event.data.type == 'login-otp' || event.data.type == 'signup-otp' || event.data.type == 'forgot-password-otp') {
                let formData = event.data.otpDetails;
                this.form = {
                    code: formData.countryCode,
                    mobileNo: formData.phoneNumber
                }
                if(event.data.type == 'forgot-password-otp'){
                    await this.sendOtpServiceCall('forgot-password');
                }
                if(event.data.type == 'signup-otp') {
                    await this.sendOtpServiceCall('registration');
                } 
                if(event.data.type == 'login-otp') {
                    await this.sendOtpServiceCall('login-otp');
                }

                const iframe = document.getElementById('landingPageIframe');
                let data = JSON.parse(JSON.stringify({...this.$store.getters.siteSettings, sendOTPRes: this.otpSuccessRes, errorRes: this.otpErrorRes } ));
                iframe.contentWindow.postMessage(data, '*');

            } else if(event.data.type == 'signup') {

                let formData = event.data.registrationDetails;
                console.log(formData)
                let isDownLine = this.getQueryParam("downline", window.location.href);

                this.form = {
                    code: formData.countryCode,
                    mobileNo: formData.phoneNumber,
                    userName: formData.username,
                    password: formData.password,
                    otp: formData.otp,
                    isDownLine: isDownLine ? isDownLine : false,
                    referCode: formData.referCode,
                }

                await this.signUpServiceCall();

                const iframe = document.getElementById('landingPageIframe');
                let data = JSON.parse(JSON.stringify({ ...this.$store.getters.siteSettings, signUpErrRes: this.signUpErrorRes }));
                iframe.contentWindow.postMessage(data, '*');

            } else if(event.data.type == 'forgot-password') {

                let formData = event.data.forgotPassDetails;
                
                this.form = {
                    code: formData.countryCode,
                    mobileNo: formData.phoneNumber,
                    otp: formData.otp,
                    password: formData.password,
                    confirmPassword: formData.confirmPassword,
                }

                await this.forgotServiceCall();

                const iframe = document.getElementById('landingPageIframe');
                let data = JSON.parse(JSON.stringify({ ...this.$store.getters.siteSettings, forgotPassErrRes : this.forgotPassErrorRes }));
                iframe.contentWindow.postMessage(data, '*');
            }
        },
    },
    unmounted() {
        window.removeEventListener('message', this.checkForEvent);
    }
};
</script>

<style>
    #landingPageIframe {
        height: 100vh;
        width: 100vw;
        position: fixed;
        inset: 0;
    }
    
</style>